import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type ProductPropertyState = readonly string[];

export const PRODUCT_PROPERTY = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ProductPropertyState>>,
): ConditionType<ProductPropertyState, Condition.ProductProperty> => ({
  name: "Product properties",
  description(state) {
    return `Product properties: ${state.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<ProductPropertyState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model: Condition.ProductProperty) {
    return model.properties;
  },
  toModel(state) {
    return { type: Condition.PRODUCT_PROPERTY, properties: state };
  },
  valid() {
    return true;
  },
});
